import { ReactNode } from "react";
import {
  IoAlertCircleOutline,
  IoCheckmarkCircleOutline,
  IoSyncCircleOutline
} from "react-icons/io5";
import { copyTextToClipboard } from "@/utils";
import { Button, Checkbox, Modal } from "barte-design-system";

interface AlertProps {
  isConfirmAlert?: boolean;
  closeButtonText?: string;
  confirmButtonText?: string;
  isOpen: boolean;
  leastDestructiveRef?: any;
  onClose?: () => void;
  onConfirm: () => void;
  title: string;
  messageBody?: string | ReactNode;
  urlBody?: string;
  children?: ReactNode;
  isLoading?: boolean;
  checkBox?: boolean;
  checkBoxValue?: boolean;
  checkBoxText?: string;
  checkBoxFunction?: (param?: boolean) => void;
  isProcessing?: boolean;
  asDeleteAlert?: string;
  hideIcon?: boolean;
}

function Alert({
  urlBody,
  isConfirmAlert,
  children,
  closeButtonText,
  confirmButtonText = "Pronto",
  isOpen,
  onClose,
  onConfirm,
  title,
  messageBody,
  isLoading = false,
  checkBox,
  checkBoxFunction,
  checkBoxText,
  checkBoxValue,
  isProcessing = false,
  hideIcon = false,
}: AlertProps) {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      footer={{
        primaryButton: {
          id: title.toLowerCase().includes("excluir") || title.toLowerCase().includes("deletar") ? "excluir_cobrança" : "",
          children: confirmButtonText,
          onClick: onConfirm,
          loading: isLoading,
        },
        ...(closeButtonText ? {
          secondaryButton: {
            children: closeButtonText,
            onClick: onClose,
            variant: "outline",
          }
        } : {}),
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {!hideIcon && (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {!isProcessing && (
              isConfirmAlert
                ? <IoCheckmarkCircleOutline size={28} color="#52C41A" />
                : <IoAlertCircleOutline size={28} color="#FAAD14" />
            )}
            {isProcessing && <IoSyncCircleOutline size={28} color="#556077" />}
          </div>
        )}
        {checkBox && (
          <Checkbox
            defaultChecked={checkBoxValue}
            onChange={(e) => checkBoxFunction(e)}
            label={checkBoxText}
          />
        )}
        {messageBody && <div>{messageBody}</div>}
        {urlBody && (
          <a style={{ color: "#4299E1", cursor: "pointer" }} onClick={() => copyTextToClipboard(urlBody)}>
            {urlBody}
          </a>
        )}
        {children}
      </div>
    </Modal>
  );
}

export { Alert };
